'use es6';

import { MOUSELEAVE_ELEMENT, MOUSELEAVE_SECTION, MOUSEOVER_ELEMENT, MOUSEOVER_SECTION, TOGGLE_FILE_MANAGER, SCROLL_CONTAINER, MOUSEOVER_COMMENTABLE_AREA, MOUSELEAVE_COMMENTABLE_AREA } from 'EmailEditorUI/redux/actions/LayoutBuilderActionTypes';
import { ELEMENT, SECTION, COMMENTABLE_AREA } from 'LayoutBuilderUI/lib/DragDropConstants';
import { getMouseOverSectionId, getMouseOverElementId } from 'LayoutBuilderUI/selectors/userInterface';
import { RESIZE_COLUMNS } from 'EmailEditorUI/redux/actions/IframeSyncedActionTypes';
import { highlightElement } from 'EmailEditorUI/redux/actions/LayoutActions';
import { getIsCustomEmail } from 'EmailEditorUI/redux/selectors/emailCategoriesSelectors';
const mouseOverActions = {
  [ELEMENT]: MOUSEOVER_ELEMENT,
  [SECTION]: MOUSEOVER_SECTION,
  [COMMENTABLE_AREA]: MOUSEOVER_COMMENTABLE_AREA
};
const mouseLeaveActions = {
  [ELEMENT]: MOUSELEAVE_ELEMENT,
  [SECTION]: MOUSELEAVE_SECTION,
  [COMMENTABLE_AREA]: MOUSELEAVE_COMMENTABLE_AREA
};
export const toggleFileManager = isOpen => {
  return {
    type: TOGGLE_FILE_MANAGER,
    isOpen
  };
};
const createHoverContentEvents = type => {
  let mouseLeaveTimeout;
  let mouseOverTimeout;
  const isElement = type === ELEMENT;
  const isCommentableArea = type === COMMENTABLE_AREA;
  const mouseLeaveAction = mouseLeaveActions[type];
  const mouseOverAction = mouseOverActions[type];
  const mouseOverSelector = isElement ? getMouseOverElementId : getMouseOverSectionId;
  const mouseOverEvent = id => (dispatch, getState) => {
    clearTimeout(mouseLeaveTimeout);
    const state = getState();
    const isCustomEmail = getIsCustomEmail(state);
    const mouseIsOver = mouseOverSelector(state) === id;
    if (!mouseIsOver) {
      mouseOverTimeout = setTimeout(() => {
        dispatch({
          type: mouseOverAction,
          id
        });
        if (isCustomEmail && !isCommentableArea) {
          dispatch(highlightElement(id, 'iframe', !isElement));
        }
      }, 0);
    }
  };
  const mouseLeaveEvent = () => (dispatch, getState) => {
    clearTimeout(mouseOverTimeout);
    const isCustomEmail = getIsCustomEmail(getState());
    mouseLeaveTimeout = setTimeout(() => {
      dispatch({
        type: mouseLeaveAction
      });
      if (isCustomEmail && !isCommentableArea) {
        dispatch(highlightElement(null, 'iframe', !isElement));
      }
    }, 0);
  };
  return {
    mouseOverEvent,
    mouseLeaveEvent
  };
};
export const hoverContentEvents = {
  [ELEMENT]: createHoverContentEvents(ELEMENT),
  [SECTION]: createHoverContentEvents(SECTION),
  [COMMENTABLE_AREA]: createHoverContentEvents(COMMENTABLE_AREA)
};
export const scrollContainer = boundaries => ({
  type: SCROLL_CONTAINER,
  boundaries
});
export const resizeColumns = (sectionIndex, newWidths) => ({
  type: RESIZE_COLUMNS,
  sectionIndex,
  newWidths
});